import { Trans } from '@lingui/macro';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useState, useEffect, useMemo } from 'react'
import Modal from 'react-modal';
import ReactQuill from 'react-quill';
import { isEmpty } from 'underscore';
import { Context } from '../../..';
import AskService from '../../../services/AskService';
import { formats, modules } from './QuillSettings';


const Comment: FC<any> = observer(data => {
    const { comment } = data;
    return (
        <div className='ms-5 ps-5 small'>
            <hr />
            <div className='h6 m-0'>{comment['fio']}</div>
            <div className='h6 m-0 text-secondary'><em>{comment['organizations']}</em></div>
            <div className='h6 m-0 text-secondary'><em>{comment['specializations']}</em></div>
            <div className=' m-0 text-success'><em>{new Date(comment['comment_date']).toLocaleDateString("ru-RU", {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            })}</em></div>
            <ReactQuill
                value={comment['comment']}
                className='react-quill'
                readOnly={true}
                theme="bubble"
            />
        </div>
    )
});

const Answer: FC<any> = observer(data => {
    const { answer, index, spec, org, getQA, getSpecQA, questioner, subject } = data;
    const { store } = useContext(Context);
    const [commentButton, setCommentButton] = useState(false);
    const [comment, setComment] = useState('');
    const [recipient, setRecipient] = useState([questioner, answer['email']]);

    
    useEffect(() => {
        answer['comments']?.forEach((comment: any) => {
            setRecipient(d => [...d, comment['email']]);
        });
    }, [answer])

    const addComment = async () => {
        try {
            await AskService.createC({
                'answer_id': answer['id'],
                'email': store.user.email,
                subject,
                comment,
                'recipient': [...new Set(recipient)],
                'fio': store.specInfo?.fio || store.userInfo?.fio,
                'specializations': spec?.join(', ') || '',
                'organizations': org?.join(', ') || ''
            });
            setCommentButton(false);
            if (store.user.is_staff) {
                getSpecQA();
            } else {
                getQA();
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getComments = () => answer['comments']?.map((comment: any, index: number) => {
        return <Comment key={comment['id']} {...{ comment, index }} />
    })

    return (
        <div className="form-control mb-3">
            <h5><Trans>Answer</Trans> №{index + 1}:</h5>
            {!isEmpty(answer) ? <>
                <div className='h6 m-0'>{answer['fio']}</div>
                <div className='h6 m-0 text-secondary'><em>{answer['organizations']}</em></div>
                <div className='h6 m-0 text-secondary'><em>{answer['specializations']}</em></div>
                <div className=' m-0 text-success'><em>{new Date(answer['answer_date']).toLocaleDateString("ru-RU", {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric'
                })}</em></div>
                <ReactQuill
                    value={answer['answer']}
                    className='react-quill'
                    readOnly={true}
                    theme="bubble"
                /></>
                : <Trans>There is no answer yet</Trans>}
            {!isEmpty(answer['comments']) ?
                getComments()
                : null}
            {commentButton ?
                <>
                    <ReactQuill
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        id="text"
                        onChange={setComment} />
                    {/* <textarea rows={3}
                        className='form-control'
                        onChange={(e: React.ChangeEvent<any>) => setComment(e.target.value)} /> */}
                    <button type='button' className='btn btn-primary m-2' onClick={addComment}>
                        <Trans>Add comment</Trans>
                    </button>
                    <button type='button' className='btn btn-warning m-2' onClick={() => setCommentButton(false)}>
                        <Trans>Cancel</Trans>
                    </button>
                </>
                :
                <div className='text-end'>
                    <button type='button' className='btn btn-light' onClick={() => setCommentButton(true)}>
                        <Trans>Add comment</Trans>
                    </button>
                </div>}
        </div>
    )
});

interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
    qaID: number;
    spec?: string[];
    org?: string[];
}

export const QAModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle, qaID, spec, org } = props;
    const { store } = useContext(Context);
    const [answerButton, setAnswerButton] = useState(false);
    const [answer, setAnswer] = useState('');
    const [data, setData] = useState<any>({});
    const quan = useMemo(() => toJS(store.qa), [store.qa])

    useEffect(() => {
        quan.forEach(item => {
            if (item['id'] === qaID) {
                setData(item);
            }
        });
    }, [qaID, quan])

    const getSpecQA = async () => {
        const qa = await AskService.getSpecQ();
        store.setQA(qa.data.results);
    };

    const getQA = async () => {
        const qa = await AskService.getQ();
        store.setQA(qa.data.results);
    };

    const addAnswertoQuestion = async () => {
        try {
            await AskService.createA({
                'question_id': data['id'],
                'email': store.user.email,
                'subject': data['subject'],
                answer,
                'recipient': data['email'],
                'fio': store.specInfo?.fio || '',
                'specializations': spec?.join(', ') || '',
                'organizations': org?.join(', ') || ''
            });
            if (store.user.is_staff) {
                getSpecQA();
            } else {
                getQA();
            }
            setAnswerButton(false);
        } catch (e) {
            console.log(e);
        }

    };

    const onRequestClose = () => {
        setToggle(false);
    };

    const getAnswers = () => data['answers']?.map((answer: any, index: number) => {
        return <Answer key={answer['id']} {...{ answer, index, spec, org, getQA, getSpecQA, subject: data['subject'], questioner: data['email'] }} />
    })

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className="form-group mb-3">
                    <h3 className="event-header text-center">{data['subject']}</h3>
                    <div className="form-control mb-3">
                        <h5><Trans>Question</Trans>:</h5>
                        <div className='h6 m-0'>{data['fio']}</div>
                        <div className=' m-0 text-success'><em>{new Date(data['question_date']).toLocaleDateString("ru-RU", {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric'
                        })}</em></div>
                        <ReactQuill
                            value={data['question']}
                            className='react-quill'
                            readOnly={true}
                            theme="bubble"
                        />
                        {store.user.is_staff && !answerButton ?
                            <div>
                                <button type='button' className='btn btn-primary' onClick={() => setAnswerButton(true)}>
                                    <Trans>Add answer</Trans>
                                </button>
                            </div>
                            : null}
                        {answerButton ? <>
                            <ReactQuill
                                theme="snow"
                                defaultValue={answer}
                                modules={modules}
                                formats={formats}
                                id="text"
                                onChange={setAnswer} />
                            <button type='button' className='btn btn-primary m-2' onClick={addAnswertoQuestion}>
                                <Trans>Add answer</Trans>
                            </button>
                            <button type='button' className='btn btn-warning m-2' onClick={() => setAnswerButton(false)}>
                                <Trans>Cancel</Trans>
                            </button>
                        </>

                            : null}
                    </div>
                    {getAnswers()}
                </div>
            </form>
        </Modal >
    );
});